// Maps English ceremonial regions to the council names used in `practices.borough`.
// Councils not listed appear under "Other areas".
export const REGIONS: { name: string; councils: string[] }[] = [
  {
    name: "London",
    councils: [
      "Barking and Dagenham", "Barking", "Barnet", "Bexley", "Brent", "Bromley",
      "Camden", "City of London", "Croydon", "Ealing", "Enfield", "Greenwich",
      "Hackney", "Hammersmith and Fulham", "Hammersmith", "Haringey", "Harrow",
      "Havering", "Hillingdon", "Hounslow", "Islington", "Kensington and Chelsea",
      "Kingston upon Thames", "Lambeth", "Lewisham", "Merton", "Newham",
      "Redbridge", "Richmond upon Thames", "Southwark", "Sutton",
      "Tower Hamlets", "Waltham Forest", "Wandsworth", "Westminster", "London",
    ],
  },
  {
    name: "Greater Manchester",
    councils: [
      "Manchester", "Salford", "Trafford", "Stockport", "Tameside", "Oldham",
      "Rochdale", "Bury", "Bolton", "Wigan",
      // Manchester neighbourhoods present in the data
      "Manchester City Centre", "Didsbury", "Chorlton", "Longsight", "Fallowfield",
      "Harpurhey", "Collyhurst", "Beswick", "Baguley", "Little Hulton",
    ],
  },
  {
    name: "West Midlands",
    councils: [
      "Birmingham", "Coventry", "Dudley", "Sandwell", "Solihull", "Walsall",
      "Wolverhampton",
      // Birmingham neighbourhoods
      "Acocks Green", "Alum Rock", "Handsworth", "Kings Heath", "Kings Norton",
      "Great Barr",
    ],
  },
  {
    name: "West Yorkshire",
    councils: ["Leeds", "Bradford", "Kirklees", "Calderdale", "Wakefield"],
  },
  {
    name: "South Yorkshire",
    councils: ["Sheffield", "Doncaster", "Rotherham", "Barnsley"],
  },
  {
    name: "Merseyside",
    councils: ["Liverpool", "Wirral", "Sefton", "St. Helens", "St Helens", "Knowsley"],
  },
  {
    name: "Tyne and Wear",
    councils: [
      "Newcastle upon Tyne", "Gateshead", "Sunderland", "North Tyneside",
      "South Tyneside", "Fenham", "Gosforth", "Byker",
    ],
  },
  {
    name: "South East",
    councils: [
      "Brighton and Hove", "Brighton", "Milton Keynes", "Reading", "Slough",
      "Bracknell Forest", "Windsor and Maidenhead", "West Berkshire",
      "Wokingham", "Buckinghamshire", "Oxfordshire", "Cherwell", "Oxford",
      "South Oxfordshire", "Vale of White Horse", "West Oxfordshire",
      "Hampshire", "Eastleigh", "Fareham", "Gosport", "Havant", "New Forest",
      "Rushmoor", "Test Valley", "Winchester", "East Hampshire", "Basingstoke and Deane",
      "Hart", "Portsmouth", "Southampton", "Isle of Wight",
      "Surrey", "Elmbridge", "Epsom and Ewell", "Guildford", "Mole Valley",
      "Reigate and Banstead", "Runnymede", "Spelthorne", "Surrey Heath", "Tandridge",
      "Waverley", "Woking",
      "Kent", "Ashford", "Canterbury", "Dartford", "Dover", "Folkestone and Hythe",
      "Gravesham", "Maidstone", "Sevenoaks", "Swale", "Thanet", "Tonbridge and Malling",
      "Tunbridge Wells", "Medway",
      "East Sussex", "Eastbourne", "Hastings", "Lewes", "Rother", "Wealden",
      "West Sussex", "Adur", "Arun", "Chichester", "Crawley", "Horsham", "Mid Sussex", "Worthing",
    ],
  },
  {
    name: "South West",
    councils: [
      "Bristol", "Bristol, City of", "Bath and North East Somerset", "Bath",
      "North Somerset", "South Gloucestershire", "Cornwall", "Devon", "Exeter",
      "East Devon", "Mid Devon", "North Devon", "South Hams", "Teignbridge",
      "Torbay", "Plymouth", "Torridge", "West Devon", "Dorset",
      "Bournemouth, Christchurch and Poole", "Somerset", "Wiltshire", "Swindon",
      "Gloucestershire", "Cheltenham", "Cotswold", "Forest of Dean", "Gloucester",
      "Stroud", "Tewkesbury", "Clifton", "Horfield", "Kingswood", "Isles of Scilly",
    ],
  },
  {
    name: "East of England",
    councils: [
      "Bedford", "Central Bedfordshire", "Luton", "Cambridge", "East Cambridgeshire",
      "Fenland", "Huntingdonshire", "South Cambridgeshire", "Peterborough",
      "Essex", "Basildon", "Braintree", "Brentwood", "Castle Point", "Chelmsford",
      "Colchester", "Epping Forest", "Harlow", "Maldon", "Rochford", "Tendring",
      "Uttlesford", "Southend-on-Sea", "Thurrock",
      "Hertfordshire", "Broxbourne", "Dacorum", "East Hertfordshire", "Hertsmere",
      "North Hertfordshire", "St Albans", "Stevenage", "Three Rivers", "Watford",
      "Welwyn Hatfield",
      "Norfolk", "Breckland", "Broadland", "Great Yarmouth", "King's Lynn and West Norfolk",
      "North Norfolk", "Norwich", "South Norfolk",
      "Suffolk", "Babergh", "East Suffolk", "Ipswich", "Mid Suffolk", "West Suffolk",
    ],
  },
  {
    name: "East Midlands",
    councils: [
      "Derby", "Derbyshire Dales", "Amber Valley", "Bolsover", "Chesterfield",
      "Erewash", "High Peak", "North East Derbyshire", "South Derbyshire",
      "Leicester", "Blaby", "Charnwood", "Harborough", "Hinckley and Bosworth",
      "Melton", "North West Leicestershire", "Oadby and Wigston", "Rutland",
      "Lincoln", "Boston", "East Lindsey", "North Kesteven", "South Holland",
      "South Kesteven", "West Lindsey", "North Lincolnshire", "North East Lincolnshire",
      "Nottingham", "Ashfield", "Bassetlaw", "Broxtowe", "Gedling", "Mansfield",
      "Newark and Sherwood", "Rushcliffe",
      "Northamptonshire", "North Northamptonshire", "West Northamptonshire",
    ],
  },
  {
    name: "North West",
    councils: [
      "Cheshire East", "Cheshire West and Chester", "Halton", "Warrington",
      "Cumbria", "Cumberland", "Westmorland and Furness",
      "Lancashire", "Blackburn with Darwen", "Blackpool", "Burnley", "Chorley",
      "Fylde", "Hyndburn", "Lancaster", "Pendle", "Preston", "Ribble Valley",
      "Rossendale", "South Ribble", "West Lancashire", "Wyre",
    ],
  },
  {
    name: "North East",
    councils: [
      "County Durham", "Darlington", "Hartlepool", "Middlesbrough",
      "Redcar and Cleveland", "Stockton-on-Tees", "Northumberland",
    ],
  },
  {
    name: "Yorkshire and the Humber",
    councils: [
      "York", "East Riding of Yorkshire", "Kingston upon Hull, City of",
      "North Yorkshire", "Hambleton", "Harrogate", "Richmondshire", "Ryedale",
      "Scarborough", "Selby", "Craven",
    ],
  },
  {
    name: "West Midlands (Counties)",
    councils: [
      "Herefordshire, County of", "Shropshire", "Telford and Wrekin",
      "Staffordshire", "Cannock Chase", "East Staffordshire", "Lichfield",
      "Newcastle-under-Lyme", "South Staffordshire", "Stafford", "Staffordshire Moorlands",
      "Tamworth", "Stoke-on-Trent",
      "Warwickshire", "North Warwickshire", "Nuneaton and Bedworth", "Rugby",
      "Stratford-on-Avon", "Warwick",
      "Worcestershire", "Bromsgrove", "Malvern Hills", "Redditch", "Worcester",
      "Wychavon", "Wyre Forest",
    ],
  },
  {
    name: "Wales",
    councils: [
      "Blaenau Gwent", "Bridgend", "Caerphilly", "Cardiff", "Carmarthenshire",
      "Ceredigion", "Conwy", "Denbighshire", "Flintshire", "Gwynedd",
      "Isle of Anglesey", "Merthyr Tydfil", "Monmouthshire", "Neath Port Talbot",
      "Newport", "Pembrokeshire", "Powys", "Rhondda Cynon Taf", "Swansea",
      "Torfaen", "Vale of Glamorgan", "Wrexham",
    ],
  },
  {
    name: "Scotland",
    councils: [
      "Aberdeen City", "Aberdeenshire", "Angus", "Argyll and Bute", "City of Edinburgh",
      "Clackmannanshire", "Dumfries and Galloway", "Dundee City", "East Ayrshire",
      "East Dunbartonshire", "East Lothian", "East Renfrewshire", "Falkirk", "Fife",
      "Glasgow City", "Highland", "Inverclyde", "Midlothian", "Moray",
      "Na h-Eileanan Siar", "North Ayrshire", "North Lanarkshire", "Orkney Islands",
      "Perth and Kinross", "Renfrewshire", "Scottish Borders", "Shetland Islands",
      "South Ayrshire", "South Lanarkshire", "Stirling", "West Dunbartonshire",
      "West Lothian",
    ],
  },
  {
    name: "Crown Dependencies",
    councils: ["Channel Islands", "Isle of Man"],
  },
];

const COUNCIL_TO_REGION = new Map<string, string>();
for (const r of REGIONS) {
  for (const c of r.councils) COUNCIL_TO_REGION.set(c.toLowerCase(), r.name);
}

export function regionForCouncil(council: string): string {
  return COUNCIL_TO_REGION.get(council.toLowerCase()) ?? "Other areas";
}

export interface CouncilCount { name: string; count: number }
export interface RegionGroup { name: string; total: number; councils: CouncilCount[] }

export function groupByRegion(rows: CouncilCount[]): RegionGroup[] {
  const map = new Map<string, CouncilCount[]>();
  for (const r of rows) {
    const region = regionForCouncil(r.name);
    if (!map.has(region)) map.set(region, []);
    map.get(region)!.push(r);
  }
  const groups: RegionGroup[] = [];
  for (const [name, councils] of map) {
    councils.sort((a, b) => b.count - a.count);
    groups.push({ name, councils, total: councils.reduce((s, c) => s + c.count, 0) });
  }
  // Predefined region order, then "Other areas" last
  const order = REGIONS.map((r) => r.name);
  groups.sort((a, b) => {
    const ai = order.indexOf(a.name);
    const bi = order.indexOf(b.name);
    if (ai === -1 && bi === -1) return b.total - a.total;
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });
  return groups;
}